"use es6";

const scaleCorrectors = {};
function addScaleCorrector(correctors) {
  Object.assign(scaleCorrectors, correctors);
}
export { addScaleCorrector, scaleCorrectors };